module.exports = __webpack_public_path__ + "static/media/img-1.87fa32b7.jpg";